import React from "react";

const SportInfrastructure=()=>{
    return(
    <>
        <h1>Sport Infrastructure</h1>
    </>
    )
}
export default SportInfrastructure